<template>
    <div class="row">
        <div class="col-lg-12">
            <div style="border: 1px dashed lightgrey;" class="panel panel-default country-select-panel text-center">
                <div class="panel-body">
                    <!--<img src="https://ch.expirenza.com/newdesign/images/finish-success-icon.png">-->
                    <br>
                    <span style="font-size:30px;">{{ $t("ui.oopsText") }}</span>
                    <br>
                    <span v-if="reason == '403'" style="font-size:20px;" v-html='$t("ui.accessDeniedText")'>
                    </span>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'error',
        data() {
            return {
                reason: ''
            }
        },
        mounted() {
            this.reason = this.$route.params.reason;
        },
        methods: {},
        components: {}
    }
</script>
